import { MainContainer } from './Container.styled';

const Container = ({ children }) => {
  return <MainContainer>{children}</MainContainer>;
};

export default Container;
